function Main({ children }) {
  return <div className="app">{children}</div>;
}

export default Main;
